export default __webpack_public_path__ + "static/media/Positions.e63f4437.svg";